module.exports = __webpack_public_path__ + "media/images/story/top/capture_congrats-d9e43e82d90220830f6a06d3d8609a53.svg";